export default __webpack_public_path__ + "static/media/investor-7.3d01aad8.png";